@if (items().length) {
  <ul>
    @for (item of items(); track item.quiz.id) {
      <li>
        <button (click)="openQuestion(item.quiz)">
          <span class="header">
            <odl-icon class="kind-icon" [name]="item.icon"></odl-icon>

            <span class="book-data">
              <span class="chapter-data">
                <span class="chapter" nrEllipsis>{{ item.chapterTitle }}</span>
                <span class="progress">{{ item.progress | number: '1.0-0' }}%</span>
              </span>

              <span class="question-name" [nrEllipsis]="2">{{ item.quiz.name }}</span>
            </span>

            <odl-button
              (click)="$event.stopImmediatePropagation()"
              [id]="triggerId(item.quiz.id)"
              [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
            >
              <odl-icon name="more_vert" slot="only-icon"></odl-icon>
            </odl-button>
            <odl-tooltip [attr.for]="'#' + triggerId(item.quiz.id)">
              {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
            </odl-tooltip>

            <odl-menu
              (click)="$event.stopImmediatePropagation()"
              [attr.for]="'#' + triggerId(item.quiz.id)"
              placement="bottom-end"
            >
              <odl-menu-item (odl-select)="requestDelete(item.quiz)">
                <odl-icon name="delete" slot="icon"></odl-icon>
                <span>{{ 'DELETE' | translate }}</span>
              </odl-menu-item>
            </odl-menu>
          </span>
        </button>
      </li>
    }
  </ul>
} @else {
  <p class="empty">{{ 'QUESTIONS.EMPTY_LIST' | translate }}</p>
}

<odl-dialog
  [label]="deleteTitleKey() | translate"
  [open]="!!pendingDelete()"
  (odl-close)="cancelDelete()"
>
  {{ deleteBodyKey() | translate }}
  <div slot="footer" class="dialog-footer">
    <odl-button variant="secondary" (click)="cancelDelete()">
      {{ 'CANCEL' | translate }}
    </odl-button>
    <odl-button variant="primary" (click)="confirmDelete()">
      {{ 'DELETE' | translate }}
    </odl-button>
  </div>
</odl-dialog>
